const FrontPage = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='FrontPage--Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='FrontPage--Riddle__Screen__Background__Image' />
                )}
            </div>

            <div className="FrontPage--Riddle__Screen__Container">
                <img src='/img/page/xolos-five.png' className='FrontPage--Riddle__Screen__Container__Logo' />

                {/* <p className="FrontPage--Riddle__Screen__Container__Title" style={{ fontFamily: '"GFS Didot", serif' }}>ADIVINA ADIVINADOR</p> */}
                <p className="FrontPage--Riddle__Screen__Container__Title">ADIVINA ADIVINADOR</p>
                <img src="/img/games/riddle/female/january-24-2026/provi-logotipo.png" className="FrontPage--Riddle__Screen__Container__BrandLogo" />
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { FrontPage };